import {data} from "jquery";
import {useGetCatgeory} from "../../../hooks/useCategory";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import {Children} from "react";
import Loader from "../../components/shared/Loader";
import SelectSubCategory from "./selectSubCategory";
import {Dropdown} from "react-bootstrap";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import CustomSelectDropdown from "./selectDropDown";

const SelectCategory = ({
  selectedSector,
  selectedCategory,
  setSelectedCategory,
  selectedSubCategory,
  setSelectedSubCategory,
  children,
}) => {
  const {data: categories, isLoading: isLoadingCategory} = useGetCatgeory();
  if (isLoadingCategory)
    return (
      <div>
        <Loader />
      </div>
    );

  const sectorCategories = categories?.filter(
    (category) => category?.fatherId === selectedSector?.id,
  );
  const handleSelect = (e) => {
    const category = sectorCategories.find((el) => el.id == e.target.value);

    if (category) setSelectedCategory(category);
  };
  return (
    <section>
      <h4 className="font-bold text-[18px]  text-[#19295C] ">
        Indiquez la catégorie
      </h4>

      <div className="flex flex-col w-full !px-2 !py-5 sm:!p-5 gap-10">
        <div className="grid grid-cols-2 w-full gap-3">
          <div className="form-group w-full col-span-2 lg:col-span-1">
            <label className="required-field-label text-base font-medium !leading-6 text-[#7E7E7E]">
              Catégorie
            </label>
            <CustomSelectDropdown
              sectorCategories={sectorCategories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />
            {/* <select className="form-control mb-3" onChange={handleSelect}>
              <option value="" disabled selected hidden>
                Choisir une catégorie
              </option>
              {sectorCategories?.map((category) => (
                <option value={category.id}>{category.title}</option>
              ))}
            </select> */}
          </div>
          <SelectSubCategory
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            setSelectedSubCategory={setSelectedSubCategory}
          />
        </div>
        {/* <div className="grid grid-cols-3 gap-5 w-full ">
          {!!sectorCategories?.length &&
            sectorCategories?.map((category) => (
              <div className="w-full " key={category.id}>
                <div
                  className={`border-2 rounded-xl border-solid flex flex-col justify-center items-center gap-5 p-4 cursor-pointer ${
                    category?.id === selectedCategory?.id &&
                    "bg-gradient-to-r from-[#0022AA] to-[#1A64B9] "
                  }`}
                  onClick={() => {
                    setSelectedCategory(category);
                  }}
                >
                  <ImageComponent
                    alt={"icon"}
                    src={buildImageUrl(selectedSector.imagePath)}
                    className={"h-16 w-auto object-contain"}
                    fallback={
                      <img alt="icon" src={NoImage} className={"h-16 w-auto"} />
                    }
                  />
                  <div
                    className={`"font-bold text-sm text-center " ${
                      category?.id === selectedCategory?.id
                        ? "text-white"
                        : "text-[#19295C]"
                    } `}
                  >
                    {category.title}
                  </div>
                </div>
              </div>
            ))}
        </div> */}
        {children}
      </div>
    </section>
  );
};
export default SelectCategory;
